import { SQSClient, SendMessageCommand } from "@aws-sdk/client-sqs";
const sqsClient = new SQSClient();
export async function queueSms({ from, to, msg, mediaUrl = "" }) {
    return sqsClient.send(new SendMessageCommand({
        QueueUrl: process.env.SMS_QUEUE_URL,
        MessageBody: JSON.stringify({
            from,
            to,
            msg,
            mediaUrl,
        }),
    }));
}
//# sourceMappingURL=send-sms.js.map